import UnderlinedTabsLayout from '@/src/ui/tabs/components/UnderlinedTabsLayout';

export interface UnderlinedTabsProps {
  tabsList: Array<TabProps>;
  onClick: (id: idType) => void;
}

export interface TabProps {
  text: string;
  id: idType;
  isActive: boolean;
}

export type idType = string | number;

const UnderlinedTabs = ({
  tabsList,
  onClick,
}: UnderlinedTabsProps): JSX.Element => {
  return <UnderlinedTabsLayout tabsList={tabsList} onClick={onClick} />;
};

export default UnderlinedTabs;
